import * as React from "react";
import styled from "styled-components/macro";
import { Power } from "react-feather";
import { useNavigate } from "react-router-dom";

import {
  Tooltip,
  Menu,
  MenuItem,
  IconButton as MuiIconButton,
} from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { route } from "../../utils/url";
import useAppDispatch from "../../hooks/useAppDispatch";
import { setArchives, setOpenedIds } from "../../redux/slices/archive/archive";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown(): React.ReactElement {
  const [anchorMenu, setAnchorMenu] = React.useState<any>(null);
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const dispatchStore = useAppDispatch();

  const toggleMenu = (event: React.SyntheticEvent): void => {
    setAnchorMenu(event.currentTarget);
  };
  /* istanbul ignore next */
  const closeMenu = (): void => {
    setAnchorMenu(null);
  };
  const openProfilePage = (): void => {
    navigate(route("profile.general-information"));
  };
  const handleSignOut = async (): Promise<void> => {
    await signOut();
    navigate(route("sign-in"));
    handleCloseArchiveFolder();
  };

  const handleCloseArchiveFolder = (): void => {
    dispatchStore(setArchives([]));
    dispatchStore(setOpenedIds([]));
  };

  return (
    <React.Fragment>
      <Tooltip title="Account">
        <IconButton
          data-testid="profile-icon-button"
          aria-owns={anchorMenu ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={toggleMenu}
          color="inherit"
          size="large"
        >
          <Power />
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorMenu}
        open={Boolean(anchorMenu)}
        onClose={closeMenu}
      >
        <MenuItem
          data-testid="navbar-dropdown-profile"
          onClick={openProfilePage}
        >
          Profile
        </MenuItem>
        <MenuItem
          data-testid="navbar-dropdown-sign-out"
          onClick={handleSignOut}
        >
          Sign out
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

export default NavbarUserDropdown;
